export const artistInterviewLinks = {
    'Angelique Nagovskaya': 'https://youtu.be/tmExsGnKrs8?si=QVEPCnsOH7Jy_EsS',
    'Vivia Wisperwind': 'https://youtu.be/ZLQ7c_bPmO4?si=A0lXnM7Xz9ga7wMh',
    'Ant Webb': 'https://youtu.be/fPU6K5_Y-gs?si=6EFHhLLzWPsEB6TC',
    'Anthony Webb': 'https://youtu.be/fPU6K5_Y-gs?si=6EFHhLLzWPsEB6TC',
    'Alexander Rhys': 'https://youtu.be/9YGfzMr13pQ?si=B2la1j9U3qvyfh0z',
    'Marta Tesoro': 'https://youtu.be/45BNTfLhwco?si=T2kQz1O6OwMehZw9',
    'Trev Clarke': 'https://youtu.be/rx_cX_IFJWE?si=lPehJgoFShKDDDSK',
    'Brighton Royal Pavilion': 'https://youtu.be/kl73VU99P-A?si=WdSc88EVLZFshl2o',
    'Barbara Safran de Niverville': 'https://youtu.be/5hcYt5gVM0E?si=xKHngXj3-Cab20Ar',
    'Melissa Hamlyn': 'https://youtu.be/e1AtXnuOuag?si=4QOcB5aSXlXNrL-1',
    'Painted Lady Studio': 'https://youtu.be/e1AtXnuOuag?si=4QOcB5aSXlXNrL-1',
    'Jo Vincent': 'https://youtu.be/rDwZ-JZ9S7M?si=YrHbBrQji1R4EvNc',
    'Christian Redermayer': 'https://youtu.be/DFwwdIGGMIg?si=f6gBTTdOTAPxYogh',
    'Paul Gittins': 'https://youtu.be/mPfiYdlogyQ?si=Aj-4dfm8pNJVRmRm',
    'Guille Giagante': 'https://youtu.be/v3TqXu7hb6s?si=RJO3G_obQZzq6BSZ',
    'Ethan Platt': 'https://youtu.be/RbPUK9j6WBg?si=GI3VOXp8G6KQ6hhw',
};

export function getArtistInterviewEmbedUrl(artistName) {
    const interviewUrl = artistInterviewLinks[artistName];

    if (!interviewUrl) {
        return null;
    }

    try {
        const parsedUrl = new URL(interviewUrl);
        let videoId = '';

        if (parsedUrl.hostname.includes('youtu.be')) {
            videoId = parsedUrl.pathname.replace('/', '');
        } else if (parsedUrl.hostname.includes('youtube.com')) {
            if (parsedUrl.pathname.startsWith('/embed/')) {
                videoId = parsedUrl.pathname.replace('/embed/', '');
            } else {
                videoId = parsedUrl.searchParams.get('v') || '';
            }
        }

        if (!videoId) {
            return null;
        }

        return `https://www.youtube.com/embed/${videoId}`;
    } catch (error) {
        return null;
    }
}
